// extracted by mini-css-extract-plugin
module.exports = {"portal":"Modal_portal___Xnf0","headerStartButton":"Modal_headerStartButton__zfGx9","body":"Modal_body__ghBXu","footer":"Modal_footer__Pw_CF"};